import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { recentHistoryBunja } from '@flipster/features/src/recent-history/state';
import { IconButton } from '@flipster/react/design-system/icon-button';
import TrashIcon from '@flipster/react/icon/generated/TrashIcon';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { MarketEvent } from '@flipster/utils/segment/events/market';

import { RecentSearchHistoryItem } from './recent-search-history-item';
import { useWheelHorizontalScroll } from './use-wheel-horizontal-scroll';

export const RecentSearchHistory = () => {
  const { historiesAtom, clearRecentSearchHistory } = useBunja(recentHistoryBunja);
  const histories = useAtomValue(historiesAtom);
  const listRef = useWheelHorizontalScroll<HTMLUListElement>();

  if (histories.length === 0) return null;

  const handleClickTrash = () => {
    clearRecentSearchHistory();
    segment.track(MarketEvent.SearchHistoryBinClick);
  };

  return (
    <div className={hstack({ my: 4, gap: 0 })}>
      <ul
        ref={listRef}
        className={css({
          display: 'flex',
          flex: 1,
          minW: 0,
          gap: 8,
          ml: 16,
          overflowX: 'auto',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
          '& > li': { flexShrink: 0 },
        })}
      >
        {histories.map((symbol, index) => (
          <RecentSearchHistoryItem key={symbol} symbol={symbol} index={index} />
        ))}
      </ul>
      <div className={css({ position: 'relative', flexShrink: 0 })}>
        <span
          className={css({
            position: 'absolute',
            right: '100%',
            top: 0,
            bottom: 0,
            w: 8,
            pointerEvents: 'none',
            background: 'linear-gradient(270deg, {colors.background.default.level-1} 0%, transparent 100%)',
          })}
        />
        <div className={hstack({ h: 'full', alignItems: 'center', bg: 'background.default.level-1', pl: 8, pr: 16 })}>
          <IconButton hierarchy='quaternary' icon={<TrashIcon />} onClick={handleClickTrash} />
        </div>
      </div>
    </div>
  );
};
